import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function TermsPage() {
  useEffect(() => {
    document.title = 'Terms of Service | AllChinaBuy Spreadsheet Hub';
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16">
          <div className="max-w-3xl mx-auto">
            <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-6">Terms of Service</h1>
            <div className="prose max-w-none text-foreground-700 leading-relaxed space-y-4">
              <p><strong>Last Updated:</strong> August 26, 2026</p>
              <p>
                Welcome to AllChinaBuy Spreadsheet Hub. By accessing and using this website, you agree to comply with these Terms of Service. If you do not agree with any part of these terms, please do not use our website.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Use of Content</h2>
              <p>
                All content on this website is provided for informational and educational purposes only. You may not reproduce, distribute, modify, or create derivative works from our content without prior written permission.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">No Professional Advice</h2>
              <p>
                The information on this website does not constitute professional, legal, financial, or purchasing advice. We are not responsible for any decisions you make based on the information provided. Always conduct your own research and consult professionals when necessary.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">External Links</h2>
              <p>
                Our website contains links to third-party websites, including kaspreadsheet.com. We are not responsible for the content, practices, or availability of these external sites. Visiting external links is at your own risk.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Disclaimer of Warranties</h2>
              <p>
                This website and its content are provided "as is" without any warranties, express or implied. We do not guarantee the accuracy, completeness, or reliability of any information. We disclaim all warranties to the fullest extent permitted by law.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Limitation of Liability</h2>
              <p>
                In no event shall we be liable for any direct, indirect, incidental, special, or consequential damages arising from your use of this website or reliance on any information provided. This includes damages related to purchasing decisions, shipping outcomes, or transactions with third-party platforms.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting. Continued use of the website after changes constitutes acceptance of the updated terms.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}